import { getPagePath, trans } from '@spotahome/soyuz/client';

import KeyWithKeyRingReverse from '@spotahome/ui-library/src/tenant/components/icons/KeyWithKeyRingReverse';
import LandingSocialBannerSection from '@spotahome/landings-common/src/components/LandingSocialBannerSection';

const HiwSocial = () => {
  return (
    <LandingSocialBannerSection
      title={trans('how_it_works.social.title')}
      cta={{
        url: getPagePath('landing'),
        text: trans('how_it_works.social.cta')
      }}
      renderIcon={() => <KeyWithKeyRingReverse />}
    />
  );
};

export default HiwSocial;
